
if(!customElements.get('video-player')) {

  class VideoPlayer extends HTMLElement {

    constructor() {
      super();
      this.init();
    }


    init() {
      this.video = this.querySelector('video');
      this.addEventListener('click', () => {
        this.handleVideoState();
      });
      this.video.onended =  ()=> {
        this.video.currentTime = 0;
        this.classList.remove('playing');
      }
    }

    handleVideoState() {
      if(this.video.paused) {
        this.playVideo();
      } else {
        this.pauseVideo();
      }
    }

    playVideo() {
      this.video.play();
      this.classList.add('playing');
    }

    pauseVideo() {
      this.video.pause();
      this.classList.remove('playing');
    }

  }

  customElements.define('video-player', VideoPlayer);

}